<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        @if (productIds?.includes(scpi.get('productId')?.value)) {
          <mat-step
            [formGroup]="scpi"
            [stepControl]="scpis?.get([i])"
            completed="false"
          >
            <ng-container formGroupName="parameters">
              <ng-template matStepLabel>{{
                scpi?.get('productName')?.value
              }}</ng-template>
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Code de parrainage"
                    [derrors]="derrors"
                  >
                    <input
                      formControlName="externalCodeParrainage"
                      type="text"
                    />
                  </pr-input-column>
                </div>
              </div>
            </ng-container>
          </mat-step>
        }
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
